import { defineRecipe } from "@chakra-ui/react";

// Define variants based on skeleton-start-color and skeleton-end-color
const skeletonRecipe = defineRecipe({
    base: {
        background: "gray.200",
        borderRadius: "md",
        animation: "pulse 1.5s ease-in-out infinite"
    },
    variants: {
        variant: {
            darkMode: {
                background: "gray.600"
            }
        }
    },
    defaultVariants: {
        variant: "darkMode"
    }
});

export default skeletonRecipe;

// import { cssVar, defineStyleConfig } from "@chakra-ui/react";

// const $startColor = cssVar("skeleton-start-color");
// const $endColor = cssVar("skeleton-end-color");

// const Skeleton = defineStyleConfig({
//     baseStyle: {
//         [$startColor.variable]: "colors.gray.200",
//         [$endColor.variable]: "colors.gray.300"
//     }
// });

// export default Skeleton;
